import { Checkbox } from 'slab'

interface EmployerRenewalStatusProps {
  renewedEmployersOnly: boolean
  onToggle: () => void
}

export function EmployerRenewalStatusFilter ({ renewedEmployersOnly, onToggle }: EmployerRenewalStatusProps) {
  return (
    <Checkbox
      checked={renewedEmployersOnly}
      onChange={onToggle}
      label='Renewed employers only'
    />
  )
}
